import { guestController } from '@/controller/guest.controller'
import { studentController } from '@/controller/student.controller'
import type { StudentGroups } from '@/dto'
import {
  getLessonStudentType,
  LESSON_STUDENT_TYPE,
} from '@/page/Lesson/_components/lessonStudentType'
import { guestsToStudentGroups } from '@/page/Lesson/Guest/_service/guestStudentGroups'
import commonRepo from '@/repository/common.repo'

/**
 * URL student type 으로 LNB 명단 소스를 분기하는 단일 진입점.
 *
 * 분기를 LNB 목록·URL→선택·fallback 세 호출부에 흩어 두면 한 곳만 누락돼도 서로 다른
 * 데이터셋을 보게 되므로 여기 한 곳에 모은다. guest 는 react-query 캐시에서 파생하고,
 * 재원생 싱글톤(studentController)엔 넣지 않아 재원생 경로 오염을 막는다.
 */
export const fetchLessonStudentGroups = async (
  pathname: string,
): Promise<StudentGroups | undefined> => {
  if (getLessonStudentType(pathname) === LESSON_STUDENT_TYPE.guest) {
    if (!commonRepo.permission.byFeature.isAllowed('CREVERSE_GUEST')) {
      return guestsToStudentGroups([])
    }

    // 실패(네트워크/5xx)는 빈 명단으로 강등해 LNB 가 빈 채 멈추거나 unhandled rejection 이
    // 되지 않게 한다(react-query 는 에러를 캐시하지 않아 재진입 시 재시도).
    const guests = await guestController.fetchGuests().catch(() => [])
    return guestsToStudentGroups(guests)
  }

  return studentController.fetchStudentGroups()
}
